import React from "react";
import { ButtonSingle } from "../../../../../widget/common/form/Button";
import AppTranslation from "../../../../../service/app_translation/AppTranslation";
import { navigate } from "../../../../../service/navigation/Navigation";
import { appRoutes } from "../../../../../routes/routes";

const SignupThirdPartyButtons = (props: { type?: number | undefined }) => {
  return (
    <ButtonSingle
      handleClick={() => navigate(appRoutes.routeNameLogin, { replace: true })}
      width={300}
      textColor="theme-sublabel"
      bgColor="trans"
      fontSize="16_17"
      fontName="book"
    >
      {AppTranslation.text("exit_without_saving")}
    </ButtonSingle>
  );
};

export default SignupThirdPartyButtons;
